// extracted by mini-css-extract-plugin
export default {"container":"BK-z","modal":"CK-z","dimensions":"DK-z","brandName":"EK-z","productName":"FK-z","labelValue":"GK-z","recipientEmail":"HK-z","recommendedFit":"IK-z","hiddenField":"JK-z"};